import React from 'react'
import { Button } from 'antd'
import { Link } from 'react-router-dom';
import RolesHelper from '../services/permisions/RolesHelper'
import { Auth } from '../services/Auth';
import { useTranslations } from '../hooks/useTranslations';

const NotFound = () => {
  const { translations } = useTranslations();
  
  // useEffect(() => {
  //   Auth.invalidateSession();
  // });
  if (RolesHelper.isAffilateUser()) {
    Auth.invalidateSession();
  }

  return (
    <div className='nf--container'>
      <div className='nf--content'>
        <h2>{translations.notFoundHeader}</h2>
        <p>{translations.notFoundTxt}</p>

        <Link to={RolesHelper.getRedirectPage()}>
          <Button type="primary" htmlType="submit" className="button" >
            {translations.goToHome}
          </Button>
        </Link>
      </div>
    </div>
  )
}


export default NotFound;